import React from 'react';
import { useTranslation } from 'react-i18next';
import useDateFormat from '../../../utils/useDateFormat';
import { useAuth } from '../../../contexts/AuthContext';
import { VehicleService } from '../../../../../shared/types/vehicle-service.types';
import { VehicleTransfer } from '../../../../../shared/types/vehicle-transfer.types';
import { FileDoc } from '../../../../../shared/types/file.types';
import DocumentList from '../../../components/DocumentList';

interface DocumentsProps {
    vin: string;
    services: VehicleService[];
    transfers: VehicleTransfer[];
    serviceTypeMap: Record<string, string>;
}

const Documents: React.FC<DocumentsProps> = ({ vin, services, transfers, serviceTypeMap }) => {
    const { t } = useTranslation();
    const formatDate = useDateFormat();
    const { user } = useAuth();
    const sortedGroups = [
        ...services.map((svc) => ({
            date: svc.createdAt,
            label: t('vehicleDetail.documents.serviceGroupLabel', { type: serviceTypeMap[svc.serviceType] ?? svc.serviceType, date: formatDate(svc.createdAt) }),
            predicate: (f: FileDoc) => f.vehicleServiceUid === svc.id,
        })),
        ...transfers.map((tr) => ({
            date: tr.createdAt,
            label: t('vehicleDetail.documents.transferGroupLabel', { date: formatDate(tr.createdAt) }),
            predicate: (f: FileDoc) => f.vehicleTransferUid === tr.id,
        })),
    ].sort((a, b) => b.date.getTime() - a.date.getTime()).map(({ label, predicate }) => ({ label, predicate }));

    return (
        <DocumentList
            filters={{ vehicleUid: vin, garageUid: user?.garageUid }}
            uploadData={{ vehicleUid: vin, garageUid: user?.garageUid }}
            groups={[
                { label: t('vehicleDetail.documents.vehicleDocuments'), predicate: (f: FileDoc) => !f.vehicleServiceUid && !f.vehicleTransferUid },
                ...sortedGroups,
            ]}
        />
    );
};

export default Documents;
